import React from 'react';

import CustomDatePicker from './DatePicker';

import * as S from './styles';

const Filter = ({ value, onChange, onSubmit }) => {
  return (
    <S.FilterWrapper>
      <CustomDatePicker value={value} onChange={onChange} />
      <button className="btn-filter-filter" onClick={onSubmit} type="button">
        Filtrar
      </button>
    </S.FilterWrapper>
  );
};

export default Filter;
